<div class="toast-container">
  <div *ngFor="let toast of toasts"
       class="toast"
       [class.toast-success]="toast.type === 'success'"
       [class.toast-error]="toast.type === 'error'"
       [class.toast-warning]="toast.type === 'warning'"
       [class.toast-info]="toast.type === 'info'"
       [class.visible]="toast.visible"
       (click)="removeToast(toast.id)">
    <span class="material-icons toast-icon">{{getIcon(toast.type)}}</span>
    <span class="toast-message">{{toast.message}}</span>
    <span class="material-icons toast-close">close</span>
  </div>
</div>
